import { create } from "zustand";

export const useMessagingStore = create((set) => ({
    lastReadTimestamps: {}, // { [chatId]: timestamp }

    setLastRead: (chatId, timestamp) =>
        set((state) => ({
            lastReadTimestamps: {
                ...state.lastReadTimestamps,
                [chatId]: timestamp,
            },
        })),

    setAllLastRead: (map) =>
        set(() => ({
            lastReadTimestamps: map, 
        })),
}));
